import axios from "axios";

export const getDeviceHealthStatusAPI = async params => {
  let response = await axios({
    url: `/api/v2/statistic/devices-health-status`,
    method: "GET",
    params
  });
  if (response.data && response.data.stat) {
    return response.data.stat;
  }
};
